import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import WritingInterface from "@/components/writing/WritingInterface";
import TopicSelector from "@/components/writing/TopicSelector";
import type { WritingSession } from "@/types/writing";
import { useChatActions } from "../ChatActionContext";

type Spec = {
  grade: string;
  topic?: string | null;
  subject?: string | null;
  writingType?: string | null;
};

export function InlineWriting({ spec }: { spec: Spec }) {
  const { reportActivity } = useChatActions();
  const [topic, setTopic] = useState<string>(spec.topic ?? "");
  const [subject, setSubject] = useState<string>(spec.subject ?? "General Writing");
  const [writingType, setWritingType] = useState<string>(spec.writingType ?? "Creative");
  const [session, setSession] = useState<WritingSession | null>(null);
  const started = !!topic;

  if (!started) {
    return (
      <Card>
        <CardContent className="p-4">
          <div className="text-sm font-medium mb-3">Writing pad · Grade {spec.grade}</div>
          <TopicSelector
            selectedGrade={spec.grade}
            onTopicSelect={(t, s, wt) => { setTopic(t); setSubject(s); setWritingType(wt); }}
          />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent className="p-3">
        <WritingInterface
          topic={topic}
          grade={spec.grade}
          subject={subject}
          writingType={writingType}
          onSubmit={(s) => {
            setSession(s);
            reportActivity(
              `The user just submitted a ${writingType} writing piece (grade ${spec.grade}, subject ${subject}) on the topic "${topic}".`,
            );
          }}
          onBack={() => { setTopic(""); setSession(null); }}
        />
      </CardContent>
    </Card>
  );
}
